import React from "react"
import KoniecCzasu from "../Zegar/koniecczasu"
import ShowOdliczanie from "../Zegar/showzegar"
//import { useOdliczanie } from "../Zegar/odliczanie"
import {Row,Col} from 'react-bootstrap'
 const ZegarOdliczanie = (props) => {
   // const [dni,godziny,minuty,sekundy] = useOdliczanie(cel,czas)

    if (props.dni+props.godziny+props.minuty+props.sekundy <= 0) {
        //if (!kon_czasu) {funk()}
        return <KoniecCzasu />
    } else {
        return (
            <Row>
                <Row>
                <Col xs={12}>
                <h4>Czas trwania konkursu : </h4>  
                </Col>
                </Row>
                <Row>  
        <ShowOdliczanie dni ={props.dni} godziny = {props.godziny} minuty = {props.minuty} sekundy = {props.sekundy} />
                </Row>
        </Row>
        )
    }
 }
 export default ZegarOdliczanie